import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

export type TCreateCouponData = {
  prefix: string | null;
  mode: string;
  confirm_code: string | null;
  name: string;
  image: string | null;
  short_description: string;
  description: string;
  point: number;
  limit: number | null;
  limit_per_user: number | null;
  is_user_per_month: boolean;
  started_at: string;
  ended_at: string;
  coupon_type_id: number;
};

const CouponService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/coupon`,
});

const CouponServices = {
  getDetail: (token: string, line_oa_code: string, id: string) =>
    CouponService.get(`/${line_oa_code}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAll: (
    token: string,
    line_oa_code: string,
    pagination: IPaginationRequest
  ) =>
    CouponService.get(
      `/${line_oa_code}/list?perPage=${pagination.per_page}&page=${pagination.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  create: (token: string, line_oa_code: string, data: TCreateCouponData) =>
    CouponService.post(`/${line_oa_code}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  edit: (
    token: string,
    line_oa_code: string,
    id: string | number,
    data: TCreateCouponData
  ) =>
    CouponService.put(`/${line_oa_code}/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  delete: (token: string, line_oa_code: string, id: string | number) =>
    CouponService.delete(`/${line_oa_code}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default CouponServices;
